export default __webpack_public_path__ + "static/media/score_multipliers_page.91f66921.png";